module.exports = __webpack_public_path__ + "static/media/12.942f8fe4.jpg";